import type {MediaConfigComponentProps} from '@cohort/merchants/apps';
import {
  FileInput,
  FileInputImageCropper,
  FileInputUploader,
} from '@cohort/merchants/components/form/input/fileInput/FileInput';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {FieldValues} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

const CohortImageMediaConfigComponent: React.FC<MediaConfigComponentProps> = ({name = 'media'}) => {
  const {control, register} = useCohortForm<FieldValues>();

  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'medias.image.configComponent',
  });

  return (
    <FileInput
      acceptHint={t('instructionFileInput')}
      assetKind="contentImage"
      name={`${name}.config.imageFileKey`}
      control={control}
      register={register}
    >
      <FileInputUploader />
      <FileInputImageCropper />
    </FileInput>
  );
};

export default CohortImageMediaConfigComponent;
